<div class="card" id="endorsement-pdf-pages">
    <app-aul-104-24 [endorsementDetails]="this.endorsementDetails()"></app-aul-104-24>
</div>
@if(this.isGeneratingPDF()) {
<app-spinner></app-spinner>
}